export {
  FacilitiesApiClient,
  facilitiesApiClient,
  createFacilitiesApiClient,
} from './facilities-api';
